import { Typography } from "@mui/material";
import { useState } from "react";

const EditableInput = ({
  value,
  onChange,
  readOnly = false,
  error = "",
  fontSize = "12px",
  type = "text",
  placeholder = "",
  sx = {},
}) => {
  const [focused, setFocused] = useState(false);

  const isEmail = type === "email";

  return (
    <>
      <input
        type={type}
        placeholder={placeholder}
        style={{
          border: isEmail
            ? error
              ? "2px solid #FF0000" // border on focus only for email
              : focused
              ? "2px solid #344CB7"
              : "1px solid #b8bdc9"
            : "none", // no border for other inputs
          outline: "none",
          borderRadius: "3px",
          padding:isEmail? "10px":'10px 0px',
          width: "100%",
          fontSize,
          fontWeight: 700,
          lineHeight: 1.45,
          backgroundColor:"white",
          ...sx,
        }}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      {error && value && (
        <Typography
          variant="subtitle2"
          fontWeight={700}
          mt="4px"
          color="#FF0000"
        >
          {error}
        </Typography>
      )}
    </>
  );
};

export default EditableInput;
